import React from 'react';
import { Providers } from './providers';
import { AppRouter } from './router';

export default function App(): React.ReactElement {
  return (
    <Providers>
      <AppRouter />
    </Providers>
  );
}
